import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { ServiceDetail } from './pages/ServiceDetail';
import { Impact } from './pages/Impact';
import { Insights } from './pages/Insights';
import { InsightDetail } from './pages/InsightDetail';
import { Contact } from './pages/Contact';
import { Products } from './pages/Products';
import { NotFound } from './pages/NotFound';
import { ScrollToTop } from './components/ScrollToTop';

export function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <ScrollToTop />
      <Helmet>
        <title>Eco Enviro - Closing the Loop. Creating Impact.</title>
        <meta name="description" content="Eco Enviro Circular Solutions manages plastic, paper, metal scrap, dry recyclables, and low-value waste through responsible recycling and RDF solutions." />
        <meta property="og:title" content="Eco Enviro Circular Solutions" />
        <meta property="og:description" content="Building India's circular economy through responsible waste management. 100,000+ MT waste diverted." />
        <meta property="og:site_name" content="Eco Enviro" />
        <meta property="og:url" content="https://theecoenviro.com" />
        <meta name="theme-color" content="#16a34a" />
      </Helmet>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:serviceId" element={<ServiceDetail />} />
        <Route path="/impact" element={<Impact />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:insightId" element={<InsightDetail />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}
